import Skeleton from "react-loading-skeleton";
import styles from "./index.module.css";

const ProductSkeletonCard = ({ isSearchDesktop }) => {
  return (
    <div
      style={{
        padding: "1rem",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        alignItems: "stretch",
      }}
      className={`${styles.productSkeleton} ${isSearchDesktop ? styles.productSkeletonSearch : ""}`}
    >
      <div style={{ width: "100%" }}>
        <Skeleton height="21rem" style={{ borderRadius: 8, display: "block" }} />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "0.6rem",
          marginTop: "0.5rem",
        }}
      >
        <Skeleton height={12} width="40%" />
        <Skeleton height={16} width="60%" />
        <Skeleton height={18} width="80%" />
      </div>
    </div>
  );
};

export default ProductSkeletonCard;
